export const LanguageCodes = ['hu', 'en'] as const;
export type LanguageCode = (typeof LanguageCodes)[number];
